import script from "./Account.vue?vue&type=script&setup=true&lang=js"
export * from "./Account.vue?vue&type=script&setup=true&lang=js"

import "./Account.vue?vue&type=style&index=0&id=58c0f756&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58c0f756"]])

export default __exports__